// 设置开机密码——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `password/index${i + 1}`,
  name: `passwordIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/password/index${i + 1}.vue`)
}))
const BranchRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `password/branch/index${i + 1}`,
  name: `passwordBranchIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/password/branch/index${i + 1}.vue`)
}))



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置开机密码——主流程，开始
    ...MainRoutes,
    // 设置开机密码——分支流程，开始
    ...BranchRoutes,


  ],
};
